module.exports = __webpack_public_path__ + "img/57.a611dc12.png";